import * as constants from '../constants';

const initialState = [];

export default function reducer(state = initialState, action) {
    switch (action.type) {
        case constants.getCalculatorsYear.success: {
            return action.payload.results;
        }

        default:
            return state;
    }
}
